export default "__VITE_ASSET__Dm2hTQVh__"